export {default as Basket} from "../icons/Basket";
export {default as Menu} from "../icons/Menu";
export {default as Search} from "../icons/Search";
export {default as Left} from "../icons/Left";
export {default as StarFill} from "../icons/StarFill";
export {default as Phone} from "../icons/Phone";
export {default as Video} from "../icons/Video";
export {default as LeftProps} from "../icons/LeftProps";
export {default as Hat} from "../icons/Hat";
export {default as Reply} from "../icons/Reply";
export {default as Heart} from "../icons/Heart";
export {default as Comment} from "../icons/Comment";
export {default as Clock} from "../icons/Clock";
export {default as Down} from "../icons/Down";
export {default as Filter} from "../icons/Filter";
export {default as BigStar} from "../icons/BigStar";
export {default as RightArrow} from "../icons/RightArrow";
export {default as MenuHome} from "../icons/MenuHome";
export {default as CourseMenu} from "../icons/CourseMenu";
export {default as TestMenu} from "../icons/TestMenu";
export {default as TherapistMenu} from "../icons/TherapistMenu";
export {default as CartMenu} from "../icons/CartMenu";
export {default as PayementMenu} from "../icons/PayementMenu";
export {default as ExitMenu} from "../icons/ExitMenu";
export {default as B1} from "../icons/B1";
export {default as B2} from "../icons/B2";
export {default as B3} from "../icons/B3";
export {default as B4} from "../icons/B4";
export {default as CartFill} from "../icons/CartFill";
export {default as User} from "../icons/User";
export {default as OfflineIcon} from "../icons/OfflineIcon";
export {default as Session} from "../icons/Session";
export {default as OnlineIcon} from "../icons/OnlineIcon";
export {default as Check} from "../icons/Check";
export {default as B1Fill} from "../icons/B1Fill";
export {default as B2Fill} from "../icons/B2Fill";
export {default as B3Fill} from "../icons/B3Fill";
export {default as B4Fill} from "../icons/B4Fill";
export {default as VideoBlack} from "../icons/VideoBlack";
export {default as RedCross} from "../icons/RedCross";
export {default as ClockWhite} from "../icons/ClockWhite";
export {default as TestMini} from "../icons/TestMini";
export {default as ArrowTop} from "../icons/ArrowTop";
export {default as ArrowDown} from "../icons/ArrowDown";
export {default as ProfileFill} from "../icons/ProfileFill";
export {default as Pencil} from "../icons/Pencil";
export {default as Play} from "../icons/Play";
export {default as Lock} from "../icons/Lock";
export {default as VideoProps} from "../icons/VideoProps";
export {default as BookletIcon} from "../icons/BookletIcon";
export {default as Download} from "../icons/Download";
export { default as QuestionMark} from "../icons/QuestionMark";
export { default as Alert} from "../icons/Alert";
export { default as MenuWallet} from "../icons/MenuWallet";
export {default as MenuDoc} from "../icons/MenuDoc";
export {default as MenuCalendar} from "../icons/MenuCalendar";
export {default as MenuPercent} from "../icons/MenuPercent";
export {default as MenuPhone} from "../icons/MenuPhone";
export {default as Upload} from "../icons/Upload";
export {default as Menu1} from "../icons/Menu1";
export {default as Workshop} from "../icons/Workshop";
export {default as Webinar} from "../icons/Webinar";
export {default as HomeIcon} from "../icons/HomeIcon";
export {default as Article} from "../icons/Article";
export {default as Discussion} from "../icons/Discussion";